import * as React from "react";
import RadioGroupFormItem from "../common/form-items/RadioGroupFormItem";
import {
  checklistNoYesOptions,
  ChecklistOption,
  checklistYesNoNotApplicableOptions,
  getFuelTypeOptions,
  PropertyType
} from "./send/ChecklistTypes";
import VerticalFormItem from "../common/form-items/VerticalBaseFormItem";
import locales from "../locales";
import TextArea from "antd/lib/input/TextArea";
import {FormComponentProps} from "antd/lib/form";
import {ChecklistFormMode, ChecklistFormProperty, PropertyValues} from "./dtos";
import ChecklistPropertyLabel from "./view/ChecklistPropertyLabel";
import Label from "../common/Label";
import ChecklistItemLayout from "./layout/ChecklistItemLayout";
import SelectFormItem from "../common/form-items/SelectFormItem";
import InputFormItem from "../common/form-items/InputFormItem";


interface Props extends FormComponentProps {
  property: ChecklistFormProperty;
  mode: ChecklistFormMode;
}

class ChecklistPropertyItem extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {property, mode} = this.props;

    const defaultNotApplicableReturnal: PropertyValues | undefined =
      (property.returnalEditable &&
        property.returnal === undefined &&
        property.rental?.value === ChecklistOption.NOT_APPLICABLE) ?
        {value: ChecklistOption.NOT_APPLICABLE} :
        undefined;

    return (
      <ChecklistItemLayout
        rentalLabel={locales.rental}
        returnalLabel={locales.return}
        showRentalLabel={(property.returnal !== undefined || mode === ChecklistFormMode.CREATE_RETURNAL) && property.rental !== undefined}
        showReturnalLabel={(property.returnal !== undefined || mode === ChecklistFormMode.CREATE_RETURNAL) && property.rental !== undefined}
        rentalChild={(property.rental || mode === ChecklistFormMode.CREATE_RENTAL) &&
            <>
              {property.rentalEditable && this.renderPropertyInput(`${property.key}-rental`, property.rentalEditable, property.type, property.rental)}
              {!property.rentalEditable && this.renderPropertyValue(property.type, property.rental)}
            </>
        }
        returnalChild={(property.returnal || mode === ChecklistFormMode.CREATE_RETURNAL) &&
            <>
              {property.returnalEditable && this.renderPropertyInput(`${property.key}-returnal`, property.returnalEditable, property.type, property.returnal ?? defaultNotApplicableReturnal)}
              {!property.returnalEditable && this.renderPropertyValue(property.type, property?.returnal)}
            </>
        }
      />
    );
  }

  private renderYesNoInput = (key: string, editable: boolean, values?: PropertyValues) => {
    const {form} = this.props;
    return (
      <>
        <RadioGroupFormItem
          style={{marginTop: -4}}
          form={form}
          fieldId={key}
          options={checklistYesNoNotApplicableOptions}
          initialValue={values?.value}
          required={true}
          disabled={!editable}
        />
        <VerticalFormItem
          style={{marginTop: -16}}
          form={form}
          fieldId={`${key}-comment`}
          initialValue={values?.comment}
          label={locales.comment}
          required={false}
          disabled={!editable}
          input={
            <TextArea maxLength={255}/>
          }
        />
      </>
    );
  };

  private renderNoYesInput = (key: string, editable: boolean, values?: PropertyValues) => {
    const {form} = this.props;
    return (
      <>
        <RadioGroupFormItem
          style={{marginTop: -4}}
          form={form}
          fieldId={key}
          options={checklistNoYesOptions}
          initialValue={values?.value}
          required={true}
          disabled={!editable}
        />
        <VerticalFormItem
          style={{marginTop: -16}}
          form={form}
          fieldId={`${key}-comment`}
          initialValue={values?.comment}
          label={locales.comment}
          required={false}
          disabled={!editable}
          input={
            <TextArea maxLength={255}/>
          }
        />
      </>
    );
  };


  private renderFuelInput = (key: string, editable: boolean, values?: PropertyValues) => {
    const {form} = this.props;
    return (
      <>
        <SelectFormItem
          style={{marginTop: -4}}
          form={form}
          fieldId={key}
          initialValue={values?.value}
          required={true}
          options={getFuelTypeOptions()}
          disabled={!editable}
        />
        <VerticalFormItem
          style={{marginTop: -16}}
          form={form}
          fieldId={`${key}-comment`}
          initialValue={values?.comment}
          label={locales.comment}
          required={false}
          disabled={!editable}
          input={
            <TextArea maxLength={255}/>
          }
        />
      </>
    );
  };

  private renderOperationHoursInput = (key: string, editable: boolean, values?: PropertyValues) => {
    const {form} = this.props;
    return (
      <>
        <InputFormItem
          style={{marginTop: -4}}
          form={form}
          fieldId={key}
          initialValue={values?.value}
          required={false}
          disabled={!editable}
          type={"number"}
          addonAfter={locales.hours}
        />
        <VerticalFormItem
          style={{marginTop: -16}}
          form={form}
          fieldId={`${key}-comment`}
          initialValue={values?.comment}
          label={locales.comment}
          required={false}
          disabled={!editable}
          input={
            <TextArea maxLength={255}/>
          }
        />
      </>
    );
  };

  private renderPropertyInput = (key: string, editable: boolean, type: PropertyType, values?: PropertyValues) => {
    if (type === 'yesNo') {
      return this.renderYesNoInput(key, editable, values);
    } else if (type === 'operationHours') {
      return this.renderOperationHoursInput(key, editable, values);
    } else if (type === 'fuel') {
      return this.renderFuelInput(key, editable, values);
    } else if (type === 'noYes') {
      return this.renderNoYesInput(key, editable, values);
    }
    return null;
  };


  private renderPropertyValue = (propertyType: PropertyType, propertyValue?: PropertyValues,) => {
    return (
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', alignItems: "start"}}>
        <ChecklistPropertyLabel
          type={propertyType}
          value={propertyValue?.value}
        />
        {propertyValue?.comment &&
            <Label
                value={propertyValue.comment}
                style={{marginLeft: 0, marginRight: 0, marginTop: 8, marginBottom: 0}}
            />
        }
      </div>
    );
  };
}

export default ChecklistPropertyItem;


// WEBPACK FOOTER //
// ./src/checklist/ChecklistPropertyItem.tsx